import { ECodeType } from '../../store/ducks/user/types';

export const EndpointsMvp = {
  //CART
  CREATE_CART: '/commerce/carts',
  CART_MINE: '/commerce/carts/mine',
  CART_MINE_ITEMS: '/commerce/carts/mine/items',
  CART_ITEMS_MINE_UPDATE: (itemId: number) =>
    `/commerce/carts/mine/items/${itemId}`,
  CART_MINE_COUNT: '/commerce/carts/mine/count',
  CART_MINE_DEACTIVATE: '/commerce/carts/mine',
  CART_MINE_ITEMS_BULK: '/commerce/carts/mine/items/bulk',
  CART_MINE_ITEMS_BULK_DELETE: '/commerce/carts/mine/items/bulk-delete',
  MINIMUN_ORDER: (cartId: string) =>
    `/commerce/carts/${cartId}/minimun_sales_order`,
  NEW_MINIMUM_ORDER: '/commerce/carts/minimum_sales_order',
  CART: (cartId: string) => `/commerce/carts/${cartId}`,
  GET_ITEMS: (cartId: string) => `/commerce/carts/${cartId}/items`,
  CART_ITEM_QUANTITY: (cartId: string) =>
    `/commerce/carts/${cartId}/items/count`,
  ADD_ITEM: (cartId: string) => `/commerce/carts/${cartId}/items`,
  ADD_ITEM_BULK: (cartId: string) => `/commerce/carts/${cartId}/items/bulk`,
  UPDATE_ITEM: (cartId: string, itemId: number) =>
    `/commerce/carts/${cartId}/items/${itemId}`,
  DELETE_ITEM: (cartId: string, itemId: number) =>
    `/commerce/carts/${cartId}/items/${itemId}`,
  NEW_DELETE_ITEM: (itemId: number) => `/commerce/carts/mine/items/${itemId}`,
  DELETE_ITEMS: (cartId: string) => `/commerce/carts/${cartId}/items`,
  SEARCH_PRODUCTS: (products: string[]) => {
    const productsTrim = encodeURIComponent(products.join(','));
    return `/commerce/products?searchCriteria[filter_groups][0][filters][0][field]=sku&searchCriteria[filter_groups][0][filters][0][value]=${productsTrim}&searchCriteria[filter_groups][0][filters][0][conditionType]=in`;
  },
  PAYMENT_CONDITION: ({ customer }: { customer: string }) =>
    `entry-order/payment-conditions/default?customer=${customer}`,

  // PRODUCTS
  SEARCH_PRODUCTS_FOR_CUSTOMER: '/search/_sql',
  FETCH_PRODUCT_DETAILS: (sku: string, soldTo: string, shipTo: string) =>
    `/commerce/products/${sku}?soldTo=${soldTo}&shipTo=${shipTo}`,
  FETCH_PURCHASE_HISTORIC: (customer: string, hidePrice: boolean) =>
    `/entry-order/last-orders?customer=${customer}&hidePrice=${hidePrice}`,
  PRODUCT_PRICING: '/product-pricing',
  PRODUCTS_SORT: '/commerce/products-sort',
  PRODUCTS_SEARCH: '/search/products-search',
  CATALOG: (soldToId: string, shipToId: string) =>
    `/commerce/catalog/bp/${soldToId}/${shipToId}`,
  CATEGORIES_LIST: (field: string, value: string, conditionType: string) =>
    `/categories/list?searchCriteria[filterGroups][0][filters][0][field]=${field}&searchCriteria[filterGroups][0][filters][0][value]=${value}&searchCriteria[filterGroups][0][filters][0][conditionType]=${conditionType}`,
  PRODUCTS_TYPES: '/search/products-type',
  PRODUCTS_PRICING: '/product-pricing',
  PRODUCTS_SEARCH_SKU_OR_INTERNAL_COD: '/search/products-search',
  SEARCH_MULT_PRODUCTS: (
    products: string[],
    codeType: ECodeType,
    customer: string,
    pageSize: number,
    currentPage: number,
    codActivityItems: string[]
  ) => {
    const productsTrim = encodeURIComponent(products.join(','));
    return `/commerce/products?searchCriteria[filter_groups][0][filters][0][field]=sap_cod_setor_atividade&searchCriteria[filter_groups][0][filters][0][value]=${codActivityItems}&searchCriteria[filter_groups][0][filters][0][conditionType]=in&searchCriteria[filter_groups][2][filters][0][field]=${codeType}&searchCriteria[filter_groups][2][filters][0][value]=${productsTrim}&searchCriteria[filter_groups][2][filters][0][conditionType]=in&searchCriteria[currentPage]=${currentPage}&searchCriteria[pageSize]=${pageSize}&soldTo=${customer}&shipTo=${customer}`;
  },
  CUSTOMER_PRODUCTS_INDEX: '/search/customer-products-index',
  CROSS_SELL_PRODUCTS: (sku: string) =>
    `/commerce/products/${sku}/links/crosssell`,
  CROSS_SELL_ITEMS: () => `/commerce/recommendations/mine/cross-sell`,
  HAS_CROSS_SELL_ITEMS: () => `/commerce/recommendations/mine/has-cross-sell`,
  WARMUP: ({ shipTo = '', soldTo = '' }) =>
    `/commerce/price/${shipTo}/${soldTo}/warmup`,

  // HELP CENTER
  HELP_CENTER_CATEGORIES: '/help-center/categories',
  HELP_CENTER_TOPICS: '/help-center/topics',

  // WISHLIST
  WISHLIST_LIST: (soldTo: string, shipTo: string) =>
    `/commerce/wishlist/mine/${soldTo}/${shipTo}`,
  WISHLIST_ADD: (soldTo: string, shipTo: string) =>
    `/commerce/wishlist/mine/item?soldTo=${soldTo}&shipTo=${shipTo}`,
  WISHLIST_REMOVE: (sku: string, soldTo: string, shipTo: string) =>
    `/commerce/wishlist/mine/item/${sku}?soldTo=${soldTo}&shipTo=${shipTo}`,

  // ABANDONED CART
  ABANDONED_CART: '/commerce/abandonedcart/mine',
  ABANDONED_CART_NOTIFY: '/commerce/abandonedcart/mine/notify'
};

export enum CookiesKey {
  ACCESS_TOKEN = '@access_token',
  SSO_ACCESS = '@sso-access',
  CART_ID = '@cart',
  EMITTER_ID = '@emitter',
  RECEIVER_ID = '@receiver',
  ORDER_CONTINUOS = '@ordercontinuos',
  AUTHORIZATION_TOKEN = '@authorization-token',
  PROFILE_ACCESS_TOKEN = '@Profile-Access-Token',
  CORRELATION_ID = '@x-correlation-id',
  COMMERCE_TOKEN = '@commerce_token'
}
